<template>
	<svg
		width="56"
		height="42"
		viewBox="0 0 56 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0 0V42L21 21V0H0ZM35 0V42L56 21V0H35Z"
			fill="#4F58F5"
		/>
	</svg>

</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

